module.exports = "<div class=\"jumbotron\">\n  <div class=\"row\">\n    <div>\n      <h1 class=\"jumbotron__caption\" ng-if=\"vm.caption\">{{ vm.caption }}</h1>\n      <div class=\"jumbotron__logo\"></div>\n      <p class=\"jumbotron__body\" ng-if=\"vm.body\">{{ vm.body }}</p>\n    </div>\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/jumbotron/jumbotron.html
 ** module id = 28
 ** module chunks = 0
 **/